export default __webpack_public_path__ + "static/media/imgpost3.7b925eba.jpg";